// Central constants for DataTableAction module

// Layout & Dimensions
export const FILTER_MENU_WIDTH = '45vh';
export const TABLE_BODY_HEIGHT = '700px';
export const FILTER_VALUE_MAX_HEIGHT = '25vh';
export const DEFAULT_ITEMS_PER_PAGE = 10;
export const DEBOUNCE_FILTER_MS = 250;

// Filter Sentinel Values
export const NONE_SENTINEL = 'NONE_SELECTED';

// API Endpoints
export const API_REMOVE_CUSTOM_LAYOUT = '/v2/financialclose/analysis/removecustomlayout';

// Logging Prefix
export const LOG_PREFIX = '[DataTableAction]';
